import "@/App.css";
import { Stage } from "@/Stage";

function App() {
  return <Stage />;
}

export default App;
